import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  constructor() { }

  camelCaseToSentenceCase(text:string){
    let result: string;
    // adding space between strings
    result = text.replace(/([A-Z])/g,' $1');
    // converting first character to uppercase and join it to the final string
    result = result.charAt(0).toUpperCase()+result.slice(1);

    //replace dashes
    result = result.replace(/-/g, ' ');

    return result;
  }

  isEmptyObject(obj) {
    return (obj && (Object.keys(obj).length === 0));
  }

  isNullOrEmpty(s:string){
    return (s === null || s === undefined || s === '');
  }

  buildLocationString(locationObj) {
    const locationDetailsMap = {}
    locationDetailsMap["location"] = ""
    if (!this.isNullOrEmpty(locationObj.streetNumber)) {
      locationDetailsMap["streetNumber"] = locationObj.streetNumber;
      locationDetailsMap["location"] += locationObj.streetNumber
    }
    if (!this.isNullOrEmpty(locationObj.street)) {
      locationDetailsMap["street"] = locationObj.street;
      locationDetailsMap["location"] += this.attachDelimitation(locationDetailsMap["location"]) + locationObj.street
    }
    if (!this.isNullOrEmpty(locationObj.city)) {
      locationDetailsMap["city"] = locationObj.city;
      locationDetailsMap["location"] += this.attachDelimitation(locationDetailsMap["location"]) + locationObj.city
    }
    if (!this.isNullOrEmpty(locationObj.district)) {
      locationDetailsMap["district"] = locationObj.district;
      locationDetailsMap["location"] += this.attachDelimitation(locationDetailsMap["location"]) + locationObj.district
    }
    if (!this.isNullOrEmpty(locationObj.countryName)) {
      locationDetailsMap["countryName"] = locationObj.countryName;
      locationDetailsMap["location"] += this.attachDelimitation(locationDetailsMap["location"]) + locationObj.countryName
    }
    if (!this.isNullOrEmpty(locationObj.countryCode)) {
      locationDetailsMap["countryCode"] = locationObj.countryCode;
      locationDetailsMap["location"] += this.attachDelimitation(locationDetailsMap["countryCode"]) + locationObj.countryCode
    }
    return locationDetailsMap;
  }

  attachDelimitation(stringToBeChecked) {
    if (!this.isNullOrEmpty(stringToBeChecked)) {
      return ", "
    } else {
      return ""
    }
  }
}
